import React from 'react';
import { AppProviders } from '@/components/app/AppProviders';
import { AppLayout } from '@/components/app/AppLayout';

const App = () => {
  return (
    <AppProviders>
      <AppLayout />
    </AppProviders>
  );
};

export default App;
